import styled from "styled-components";
import Loader from "../../Loader";
const Loading = styled(Loader).attrs(props => ({
  light: true,
  message: props.children
})).withConfig({
  displayName: "Loading",
  componentId: "sc-ln0ull-0"
})(["align-self:center;"]);
export default Loading;